<template>
<v-container>
  <v-layout row wrap class="rowbug">
    <v-flex sm12 xs12  ref="chart" :style="'height:' + alto + 'px;'" />
    
      <v-row sm12 xs12 class="rowbug"  v-for="(item, index) in avances" :key="index" >
          <v-flex class="black--text" v-if="label" >
              <v-icon x-small :style="{ color: item.color }">fa-circle</v-icon>
              {{item.avanceText}} <small>%</small>
          </v-flex> 
          <v-flex v-else>
            <v-icon x-small :style="{ color: item.color }">fa-circle</v-icon>
              {{item.nombre}} - ({{item.avanceText}} <small>%</small>)  
          </v-flex>
      </v-row>
    
  </v-layout>
</v-container>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
export default {
  name: "pnsGauge",
  props: {
    avances: {
      type: Array,
      required: true,
      default: null
    },   
    alto: {
      type: Number,
      required: false,
      default: 200
    },
    label: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      gaugeColors: [],
      colores: ["#46c49e", "#99D558", "#0d93aa"],
      chart: ""
    };
  },
  methods: {
    renderChart() {
      
      if (this.chart) {
        this.chart.dispose();
      }
      if (this.color.length > 0) {
        this.gaugeColors.push(am4core.color(this.$pSBC(0.5, this.color))); // lighter
        this.gaugeColors.push(am4core.color(this.color));
        this.gaugeColors.push(am4core.color(this.$pSBC(-0.5, this.color))); // darker
      } else {
        this.colores.forEach(color => {
          this.gaugeColors.push(am4core.color(color));
        });
      }

      
      let chart = am4core.create(this.$refs.chart, am4charts.RadarChart);
      chart.data = this.avances;
      chart.startAngle = 105;
      chart.endAngle = 435;
      chart.innerRadius = am4core.percent(30);
      chart.marginBottom = 0;
      chart.marginLeft = 0;
      chart.marginRight = 0;
      chart.marginTop = 0;
      chart.paddingBottom = -parseInt(this.alto / 20);
      chart.paddingLeft = 10;
      chart.paddingRight = 10; 
      chart.paddingTop = -10; 
      chart.colors.list = this.gaugeColors;
      chart.contentValign = "top";
      
      if (chart.logo != undefined)
        chart.logo.height = -15000;
      
      chart.numberFormatter.numberFormat = ("es-CO", { maximumFractionDigits: 2 });
      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.minGridDistance = 1;
      categoryAxis.dataFields.category = "nombre";
      categoryAxis.renderer.grid.template.disabled = false;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.strokeOpacity = 0.1;
      categoryAxis.renderer.labels.template.disabled = true;
      let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      let valueGridTpl = valueAxis.renderer.grid.template;
      valueAxis.renderer.minLabelPosition = 0.05;
      valueAxis.renderer.maxLabelPosition = 0.95;
      var label = valueAxis.renderer.labels.template;
      label.adapter.dx = -50;
      label.wrap = true;
      label.rotation = 0;
      label.fontSize = 14;
      label.paddingBottom = 0;
      label.paddingTop = 0;
      label.paddingRight = 0;
      label.paddingLeft = 0;
      label.strokeOpacity = 1;
      label.disabled = this.label;
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = false;

      valueAxis.renderer.ticks.template.disabled = this.label;
      valueAxis.renderer.ticks.template.strokeOpacity = 0.2;
      valueAxis.renderer.ticks.template.strokeWidth = 1;
      valueAxis.renderer.ticks.template.length = 10;
      valueAxis.renderer.grid.template.disabled = this.label;
      valueAxis.renderer.grid.template.above = true;

      // Create series
      let columnWidthPercent = 50;
      let series1 = chart.series.push(new am4charts.RadarColumnSeries());
      series1.showOnInit = true;
      series1.dataFields.valueX = "max";
      series1.dataFields.categoryY = "nombre";
      series1.clustered = false;
      series1.columns.template.fill = am4core.color("#000000");
      series1.columns.template.fillOpacity = 0.05;
      series1.columns.template.strokeWidth = 0;
      series1.columns.template.width = am4core.percent(columnWidthPercent);

      let series2 = chart.series.push(new am4charts.RadarColumnSeries());
      series2.showOnInit = false;
      series2.dataFields.valueX = "avance";
      series2.dataFields.categoryY = "nombre";
      // series2.clustered = true;
      series2.tooltip.disabled = this.label;

      series2.tooltip.fontSize = "1rem";
      series2.columns.template.strokeWidth = 0;
      series2.columns.template.width = am4core.percent(columnWidthPercent);
      series2.columns.template.tooltipText =
        "[bold]{nombre}: [normal]{avance}[/]" + "%";
      series2.columns.template.radarColumn.cornerRadius = 0;
      series2.columns.template.adapter.add("fill", function(fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });
      this.chart = chart;
    }
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    avances: function(newVal, oldVal) {
      this.renderChart();
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>